"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ShieldCheck: ['shield-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,3.775a1.537,1.537,0,0,0-.89-1.406A22.143,22.143,0,0,0,12,.5,22.143,22.143,0,0,0,2.89,2.369,1.537,1.537,0,0,0,2,3.775v7.637A12.285,12.285,0,0,0,9.828,22.88l1.067.414a3.063,3.063,0,0,0,2.21,0l1.067-.414A12.285,12.285,0,0,0,22,11.412ZM18.508,8.239l-6.035,8.232a1.251,1.251,0,0,1-.912.507c-.033,0-.065,0-.1,0a1.248,1.248,0,0,1-.884-.367L6,12.036a1.25,1.25,0,0,1,1.768-1.767l3.341,3.342a.25.25,0,0,0,.379-.029l5-6.821a1.25,1.25,0,1,1,2.016,1.478Z']],
  ShieldCheck1: ['shield-check-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.953A1.96,1.96,0,0,0,22.045.006H1.96A1.961,1.961,0,0,0,.012,1.964L0,9.306A15.145,15.145,0,0,0,11.861,23.974a.976.976,0,0,0,.4,0A15.144,15.144,0,0,0,23.988,9.2ZM12,17.994a7.25,7.25,0,0,1,0-14.5,1,1,0,1,1,0,2,5.25,5.25,0,1,0,5.167,6.19,1,1,0,1,1,1.967.356A7.241,7.241,0,0,1,12,17.994ZM18.957,5.349a1,1,0,0,1,0,1.414l-5.7,5.7a1.787,1.787,0,0,1-2.519,0L8.949,10.669a1,1,0,0,1,1.415-1.415l1.282,1.284a.5.5,0,0,0,.708,0l5.189-5.189A1,1,0,0,1,18.957,5.349Z']],
  SecurityRemoteUnlock: ['security-remote-unlock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,11.625a2,2,0,0,0-2-2h-.25a.5.5,0,0,1-.5-.5v-2.5a6.751,6.751,0,0,0-12.9-2.794A1.25,1.25,0,1,0,8.129,4.866,4.251,4.251,0,0,1,16.25,6.625v2.5a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2Zm-9.5,9.5a1.41,1.41,0,1,1,1.409-1.409A1.408,1.408,0,0,1,12,21.125Zm2.917-3.7a.75.75,0,0,1-1.054.113,2.945,2.945,0,0,0-3.725,0A.75.75,0,0,1,9.2,16.367a4.436,4.436,0,0,1,5.609,0A.75.75,0,0,1,14.917,17.422Zm1.666-2.41a.75.75,0,0,1-1.054.113,5.577,5.577,0,0,0-7.058,0,.75.75,0,0,1-.942-1.168,7.068,7.068,0,0,1,8.942,0A.75.75,0,0,1,16.583,15.012Z']],
  SecurityUnlock: ['security-unlock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,12.126a2.5,2.5,0,0,0-2.5-2.5H19a.25.25,0,0,1-.25-.25V6.625a6.75,6.75,0,0,0-13.5,0,1.25,1.25,0,0,0,2.5,0,4.25,4.25,0,0,1,8.5,0V9.376a.25.25,0,0,1-.25.25H4.5a2.5,2.5,0,0,0-2.5,2.5v1.5a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5Zm-16.5,1.5a1,1,0,1,1,1-1A1,1,0,0,1,5.5,13.625Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,9.5,13.625Z', 'M19.5,17.625H4.5a2.5,2.5,0,0,0-2.5,2.5v1.5a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5v-1.5A2.5,2.5,0,0,0,19.5,17.625Zm-14,4a1,1,0,1,1,1-1A1,1,0,0,1,5.5,21.625Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,9.5,21.625Z']],
  ShieldAdd: ['shield-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.043.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.146,15.146,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2L24,1.953A1.959,1.959,0,0,0,22.043.006ZM18,14.506a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5Z', 'M15.5,9.006h-2a.5.5,0,0,1-.5-.5v-2a1,1,0,0,0-2,0v2a.5.5,0,0,1-.5.5h-2a1,1,0,0,0,0,2h2a.5.5,0,0,1,.5.5v2a1,1,0,0,0,2,0v-2a.5.5,0,0,1,.5-.5h2a1,1,0,0,0,0-2Z']],
  SecurityRemoteLock: ['security-remote-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,11.625a2,2,0,0,0-2-2h-.25a.5.5,0,0,1-.5-.5v-2.5a6.75,6.75,0,0,0-13.5,0v2.5a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2Zm-13.75-5a4.25,4.25,0,0,1,8.5,0v2.5a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5ZM12,21.125a1.41,1.41,0,1,1,1.409-1.409A1.408,1.408,0,0,1,12,21.125Zm2.917-3.7a.75.75,0,0,1-1.054.113,2.945,2.945,0,0,0-3.725,0A.75.75,0,0,1,9.2,16.367a4.436,4.436,0,0,1,5.609,0A.75.75,0,0,1,14.917,17.422Zm1.666-2.41a.75.75,0,0,1-1.054.113,5.577,5.577,0,0,0-7.058,0,.75.75,0,0,1-.942-1.168,7.068,7.068,0,0,1,8.942,0A.75.75,0,0,1,16.583,15.012Z']],
  ComputerBug: ['computer-bug', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.613,8.5h8.812a1.218,1.218,0,0,0,1.191-1.481A5.7,5.7,0,0,0,16.053,4.2a.5.5,0,0,1-.027-.68A3.386,3.386,0,0,0,17,1.359a3.2,3.2,0,0,0,0-.326H17C16.914.109,16.287,0,16.007,0s-.907.105-.992,1.03l-.007.092c0,.038,0,.077,0,.118,0,.423-.262.726-.76,1.268-.025.027-.049.055-.073.083a.5.5,0,0,1-.525.151,5.569,5.569,0,0,0-3.29,0A.5.5,0,0,1,9.831,2.6c-.022-.026-.045-.052-.068-.077-.5-.544-.757-.847-.759-1.271,0-.04,0-.08,0-.118V1.037H8.994C8.908.111,8.282.006,8,.006S7.1.111,7.01,1.036a1.659,1.659,0,0,0,0,.323,3.462,3.462,0,0,0,.966,2.167.5.5,0,0,1-.027.681A5.691,5.691,0,0,0,6.4,6.968,1.25,1.25,0,0,0,7.613,8.5Z', 'M2.5,13.843a1,1,0,0,0,.707-.293l.239-.241c.778-.786,1.45-1.466,2.3-1.466a.5.5,0,0,1,.5.5v1.281a.5.5,0,0,1-.441.5,5.681,5.681,0,0,0-3.286,2.035l-.23.233A1,1,0,1,0,3.707,17.8l.239-.241A5.312,5.312,0,0,1,5.685,16.2a.422.422,0,0,1,.565.4A4.018,4.018,0,0,0,6.541,18a.5.5,0,0,1-.327.657,6.523,6.523,0,0,0-2.691,1.905l-.23.232a1,1,0,1,0,1.414,1.414l.239-.241c.778-.786,1.45-1.466,2.3-1.466h.518a.5.5,0,0,1,.394.191,25.871,25.871,0,0,0,2.646,2.834,1.753,1.753,0,0,0,2.383,0A25.877,25.877,0,0,0,15.839,20.7a.5.5,0,0,1,.393-.191h.518c.854,0,1.526.68,2.3,1.466l.239.241A1,1,0,0,0,20.707,20.8l-.23-.232a6.526,6.526,0,0,0-2.69-1.905A.5.5,0,0,1,17.459,18a4.013,4.013,0,0,0,.291-1.41.422.422,0,0,1,.565-.4,5.312,5.312,0,0,1,1.739,1.365l.239.241a1,1,0,0,0,1.414-1.414l-.23-.233a5.681,5.681,0,0,0-3.286-2.035.5.5,0,0,1-.441-.5V12.343a.5.5,0,0,1,.5-.5c.854,0,1.526.68,2.3,1.466l.239.241a1,1,0,0,0,1.414-1.414l-.23-.233c-.956-.965-2.038-2.06-3.727-2.06H5.75c-1.689,0-2.771,1.1-3.727,2.06l-.23.233A1,1,0,0,0,2.5,13.843Z']],
  SecurityLock: ['security-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,12.126a2.5,2.5,0,0,0-2.5-2.5h-.25a.5.5,0,0,1-.5-.5v-2.5a6.75,6.75,0,0,0-13.5,0v2.5a.5.5,0,0,1-.5.5H4.5a2.5,2.5,0,0,0-2.5,2.5v1.5a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5Zm-16.5,1.5a1,1,0,1,1,1-1A1,1,0,0,1,5.5,13.625Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,9.5,13.625Zm6.75-4.5a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5v-2.5a4.25,4.25,0,0,1,8.5,0Z', 'M19.5,17.625H4.5a2.5,2.5,0,0,0-2.5,2.5v1.5a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5v-1.5A2.5,2.5,0,0,0,19.5,17.625Zm-14,4a1,1,0,1,1,1-1A1,1,0,0,1,5.5,21.625Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,9.5,21.625Z']],
  Firewall: ['firewall', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.250 19.214 L15.750 19.214 L15.750 23.464 L5.250 23.464 Z', 'M.75,19.214a.25.25,0,0,0-.25.25v3a1,1,0,0,0,1,1h2a.25.25,0,0,0,.25-.25v-3.75a.25.25,0,0,0-.25-.25Z', 'M23.25,17.714a.25.25,0,0,0,.25-.25v-3a1,1,0,0,0-1-1H12a.25.25,0,0,0-.25.25v3.75a.25.25,0,0,0,.25.25Z', 'M17.25,23.214a.25.25,0,0,0,.25.25h5a1,1,0,0,0,1-1v-3a.25.25,0,0,0-.25-.25H17.5a.25.25,0,0,0-.25.25Z', 'M10,17.714a.25.25,0,0,0,.25-.25v-3.75a.25.25,0,0,0-.25-.25H1.5a1,1,0,0,0-1,1v3a.25.25,0,0,0,.25.25Z', 'M17.628,4.73h-.261L15.794,6.7a.25.25,0,0,1-.437-.091,9.491,9.491,0,0,1,.124-5.414.5.5,0,0,0-.545-.65,9.518,9.518,0,0,0-6.915,4.6.25.25,0,0,1-.182.121A.253.253,0,0,1,7.631,5.2l-1.1-1.067a.5.5,0,0,0-.73.035,7.475,7.475,0,0,0-1.414,7.122.249.249,0,0,0,.238.173H7.954a.25.25,0,0,0,.246-.205,5.315,5.315,0,0,1,2.657-3.732.5.5,0,0,1,.729.582,3.943,3.943,0,0,0,.258,2.9.251.251,0,0,0,.212.136,1.29,1.29,0,0,0,1.083-.663.5.5,0,0,1,.763-.109,2.806,2.806,0,0,1,.66.938.251.251,0,0,0,.229.149H18.37a.251.251,0,0,0,.238-.173,7.482,7.482,0,0,0-.98-6.561Z']],
  ShieldHome: ['shield-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.953A1.96,1.96,0,0,0,22.044.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.147,15.147,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2ZM18.823,9.625a.5.5,0,0,1-.323.882h-1a.5.5,0,0,0-.5.5v4.5a.5.5,0,0,1-.5.5H14a.5.5,0,0,1-.5-.5v-2.25a1.5,1.5,0,1,0-3,0v2.25a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5v-4.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.323-.882l6.5-5.5a.5.5,0,0,1,.646,0Z']],
  ShieldSearch: ['shield-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.500 9.006 A3.500 3.500 0 1 0 14.500 9.006 A3.500 3.500 0 1 0 7.500 9.006 Z', 'M24,1.953A1.96,1.96,0,0,0,22.044.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.147,15.147,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2Zm-5.793,14.26a1,1,0,0,1-1.414,0l-2.534-2.534a.25.25,0,0,0-.311-.034,5.509,5.509,0,1,1,1.691-1.691.25.25,0,0,0,.034.311L18.207,14.8A1,1,0,0,1,18.207,16.213Z']],
  ShieldKey: ['shield-key', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.953A1.959,1.959,0,0,0,22.043.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.146,15.146,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2ZM19.5,5.786a.5.5,0,0,1-.147.354l-4.577,4.568a.5.5,0,0,0-.12.513,4,4,0,1,1-2.507-2.512.5.5,0,0,0,.505-.111l4.7-4.467a.5.5,0,0,1,.345-.137H19a.5.5,0,0,1,.5.5Z', 'M9.784,11.1a1.75,1.75,0,1,0,2.475,0A1.752,1.752,0,0,0,9.784,11.1Z']],
  ShieldMonitor: ['shield-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.5,11.256a.5.5,0,0,0,.5-.5V5.506a.251.251,0,0,0-.25-.25H7.25a.251.251,0,0,0-.25.25v5.25a.5.5,0,0,0,.5.5Z', 'M24,1.954A1.96,1.96,0,0,0,22.043.006H1.96A1.961,1.961,0,0,0,.012,1.964L0,9.306A15.144,15.144,0,0,0,11.861,23.974a.976.976,0,0,0,.4,0A15.144,15.144,0,0,0,23.988,9.2ZM18.5,12.006a1.752,1.752,0,0,1-1.75,1.75h-3.5a.5.5,0,0,0-.5.5v.5a.5.5,0,0,0,.5.5h1.375a.75.75,0,0,1,0,1.5H9.375a.75.75,0,0,1,0-1.5H10.75a.5.5,0,0,0,.5-.5v-.5a.5.5,0,0,0-.5-.5H7.25a1.752,1.752,0,0,1-1.75-1.75v-6.5a1.753,1.753,0,0,1,1.75-1.75h9.5a1.753,1.753,0,0,1,1.75,1.75Z']],
  ShieldWarning: ['shield-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.42.574A1.941,1.941,0,0,0,22.044.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.147,15.147,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2L24,1.953A1.938,1.938,0,0,0,23.42.574ZM18.289,15.32a1.455,1.455,0,0,1-1.233.686H6.944a1.455,1.455,0,0,1-1.233-.686,1.433,1.433,0,0,1-.048-1.409l5.056-9.634a1.45,1.45,0,0,1,2.562,0h0l5.056,9.634A1.433,1.433,0,0,1,18.289,15.32Z', 'M11.000 13.506 A1.000 1.000 0 1 0 13.000 13.506 A1.000 1.000 0 1 0 11.000 13.506 Z', 'M12,11.756a.75.75,0,0,0,.75-.75v-3a.75.75,0,0,0-1.5,0v3A.75.75,0,0,0,12,11.756Z']],
  ShieldBug: ['shield-bug', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.953A1.96,1.96,0,0,0,22.044.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.147,15.147,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2ZM17.449,9.945a.5.5,0,0,1,0,.707l-.805.805a.474.474,0,0,0,0,.669,2,2,0,1,1-2.828,2.829.474.474,0,0,0-.67,0l-1,1a.5.5,0,0,1-.707,0l-.915-.914a.5.5,0,0,1-.063-.63c.515-.776,1.007-1.962.1-2.87s-2.094-.415-2.871.1a.5.5,0,0,1-.629-.063l-.914-.915a.5.5,0,0,1,0-.707l1-1a.474.474,0,0,0,0-.67A2,2,0,0,1,9.975,5.457a.473.473,0,0,0,.669,0l.8-.8a.5.5,0,0,1,.707,0l.915.915a.5.5,0,0,1,.063.629,1.965,1.965,0,0,0,2.771,2.772.5.5,0,0,1,.629.063Z']],
  ComputerBug1: ['computer-bug-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.019,8.8a.251.251,0,0,0,.19-.413,9.564,9.564,0,0,0-2.134-1.851.251.251,0,0,1-.059-.369,6.572,6.572,0,0,0,1.343-2.849,1.751,1.751,0,1,0-2-.2,4.518,4.518,0,0,1-1.364,2.292.251.251,0,0,1-.239.053,9.454,9.454,0,0,0-5.508,0,.252.252,0,0,1-.24-.053A4.539,4.539,0,0,1,7.642,3.114a1.75,1.75,0,1,0-2,.2,6.578,6.578,0,0,0,1.344,2.85.25.25,0,0,1-.06.369A9.539,9.539,0,0,0,4.791,8.383a.251.251,0,0,0,.19.413Z', 'M11.25,10.8a.5.5,0,0,0-.5-.5H5.014a.51.51,0,0,1-.2-.043L1.9,8.957a1,1,0,0,0-.812,1.828l1.476.657a.5.5,0,0,1,.279.59,9.133,9.133,0,0,0-.234,1.09.5.5,0,0,1-.5.424H1a1,1,0,0,0,0,2H2.115a.5.5,0,0,1,.493.424,9.474,9.474,0,0,0,.334,1.409.5.5,0,0,1-.258.6l-1.458.711a1,1,0,0,0,.439,1.9.985.985,0,0,0,.438-.1l1.461-.713a.5.5,0,0,1,.63.165,9.5,9.5,0,0,0,6.486,4.009.5.5,0,0,0,.57-.5Z', 'M12.75,23.452a.5.5,0,0,0,.57.5,9.5,9.5,0,0,0,6.486-4.009.5.5,0,0,1,.63-.165l1.461.713a.985.985,0,0,0,.438.1,1,1,0,0,0,.439-1.9l-1.458-.711a.5.5,0,0,1-.258-.6,9.458,9.458,0,0,0,.334-1.41.5.5,0,0,1,.494-.423H23a1,1,0,0,0,0-2H21.886a.5.5,0,0,1-.5-.424,9.133,9.133,0,0,0-.234-1.09.5.5,0,0,1,.279-.59l1.476-.657A1,1,0,0,0,22.1,8.957l-2.911,1.3a.51.51,0,0,1-.2.043H13.25a.5.5,0,0,0-.5.5Z']],
  ShieldGlobe: ['shield-globe', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.954A1.96,1.96,0,0,0,22.043.006H1.96A1.961,1.961,0,0,0,.012,1.964L0,9.305v0A15.143,15.143,0,0,0,11.861,23.974a.976.976,0,0,0,.4,0A15.144,15.144,0,0,0,23.988,9.2ZM10.1,13.179a.5.5,0,0,1,.469-.674h2.91a.5.5,0,0,1,.469.674,9.439,9.439,0,0,1-1.736,2.928.254.254,0,0,1-.188.084.248.248,0,0,1-.187-.085A9.419,9.419,0,0,1,10.1,13.179ZM10.1,11.505a.5.5,0,0,1-.5-.435,8.438,8.438,0,0,1-.071-1.065A8.248,8.248,0,0,1,9.6,8.941a.5.5,0,0,1,.5-.436h3.865a.5.5,0,0,1,.5.436,8.016,8.016,0,0,1,0,2.129.5.5,0,0,1-.5.435Zm-4.567-1.5a6.266,6.266,0,0,1,.1-1.086.5.5,0,0,1,.492-.414H8.076a.5.5,0,0,1,.5.548c-.029.307-.046.624-.046.952s.017.646.046.953a.5.5,0,0,1-.5.547H6.117a.5.5,0,0,1-.492-.413A6.278,6.278,0,0,1,5.528,10.005Zm8.424-3.173a.5.5,0,0,1-.469.673h-2.91a.5.5,0,0,1-.468-.673,9.413,9.413,0,0,1,1.736-2.926.248.248,0,0,1,.187-.084.254.254,0,0,1,.188.084A9.425,9.425,0,0,1,13.952,6.832Zm1.53,2.221a.5.5,0,0,1,.5-.548h1.959a.5.5,0,0,1,.493.414,6.2,6.2,0,0,1,0,2.173.5.5,0,0,1-.493.413H15.98a.5.5,0,0,1-.5-.547c.029-.307.046-.624.046-.953S15.511,9.36,15.482,9.053Zm2.172-2.3a.5.5,0,0,1-.432.751H15.6a.5.5,0,0,1-.48-.36,10.155,10.155,0,0,0-1.4-2.952A.249.249,0,0,1,14,3.813,6.534,6.534,0,0,1,17.654,6.754Zm-7.6-2.941a.25.25,0,0,1,.282.38A10.155,10.155,0,0,0,8.933,7.145a.5.5,0,0,1-.48.36H6.835A.5.5,0,0,1,6.4,6.754,6.531,6.531,0,0,1,10.057,3.813ZM6.4,13.256a.5.5,0,0,1,.432-.751H8.453a.5.5,0,0,1,.48.361,10.148,10.148,0,0,0,1.4,2.951.25.25,0,0,1-.282.381A6.527,6.527,0,0,1,6.4,13.256ZM14,16.2a.251.251,0,0,1-.282-.381,10.148,10.148,0,0,0,1.405-2.951.5.5,0,0,1,.48-.361h1.618a.5.5,0,0,1,.432.751A6.53,6.53,0,0,1,14,16.2Z']],
  ShieldWall: ['shield-wall', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.953A1.959,1.959,0,0,0,22.043.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.146,15.146,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2ZM18.5,6.006v.5a.5.5,0,0,1-.5.5H13.25a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,.5-.5H17A1.5,1.5,0,0,1,18.5,6.006Zm-8.5,5a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,.5-.5H7.5a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-.5.5Zm10-2a.5.5,0,0,1,.5-.5H18a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-.5.5H16.5a.5.5,0,0,1-.5-.5Zm-9-4.5h3.75a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5v-.5A1.5,1.5,0,0,1,7,4.506Zm-1.5,9v-.5a.5.5,0,0,1,.5-.5h4.75a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-.5.5H7A1.5,1.5,0,0,1,5.5,13.506Zm11.5,1.5H13.25a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,.5-.5H18a.5.5,0,0,1,.5.5v.5A1.5,1.5,0,0,1,17,15.006Z']],
  ShieldPhone: ['shield-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.750 4.506 L15.250 4.506 L15.250 14.256 L8.750 14.256 Z', 'M22.043.006H1.96A1.961,1.961,0,0,0,.012,1.964L0,9.306A15.144,15.144,0,0,0,11.861,23.974a.976.976,0,0,0,.4,0A15.144,15.144,0,0,0,23.988,9.2L24,1.954A1.96,1.96,0,0,0,22.043.006ZM16.75,15.756A1.758,1.758,0,0,1,15,17.506H9a1.758,1.758,0,0,1-1.75-1.75v-11A1.758,1.758,0,0,1,9,3.006h6a1.758,1.758,0,0,1,1.75,1.75Z', 'M8.750 4.506 L15.250 4.506 L15.250 14.256 L8.750 14.256 Z']],
  ShieldUnlock: ['shield-unlock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.000 12.244 A1.500 1.500 0 1 0 13.000 12.244 A1.500 1.500 0 1 0 10.000 12.244 Z', 'M24,1.954A1.96,1.96,0,0,0,22.043.006H1.96A1.961,1.961,0,0,0,.012,1.964L0,9.306A15.144,15.144,0,0,0,11.861,23.974a.976.976,0,0,0,.4,0A15.144,15.144,0,0,0,23.988,9.2ZM19.75,8.743a.75.75,0,1,1-1.5,0v-2a1.75,1.75,0,0,0-3.5,0v1.5a.25.25,0,0,0,.25.25,1,1,0,0,1,1,1v5.5a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1v-5.5a1,1,0,0,1,1-1h5a.25.25,0,0,0,.25-.25v-1.5a3.25,3.25,0,0,1,6.5,0Z']],
  ComputerShield: ['computer-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.483,15.976a.248.248,0,0,0-.176-.146.245.245,0,0,0-.221.059A8.592,8.592,0,0,1,.181,17.4a.288.288,0,0,0-.18.23.282.282,0,0,0,.13.26l1.96,1.17a.25.25,0,0,1,.095.328l-.745,1.472a.282.282,0,0,0,.03.28.288.288,0,0,0,.26.11,8.959,8.959,0,0,0,3.8-1.365.251.251,0,0,0,.061-.371A14.628,14.628,0,0,1,3.483,15.976Z', 'M3.869,8.733c.414-.21.9-.434,1.456-.656a.252.252,0,0,0,.157-.233L5.465,3.752H18.5L18.5,7.835a.25.25,0,0,0,.157.232c.563.225,1.06.453,1.48.665a.245.245,0,0,0,.243-.01.252.252,0,0,0,.12-.212L20.5,3.7a1.959,1.959,0,0,0-1.956-1.947H5.461A1.96,1.96,0,0,0,3.513,3.711l-.006,4.8a.25.25,0,0,0,.119.213A.248.248,0,0,0,3.869,8.733Z', 'M17.8,18.127a2.475,2.475,0,0,1-1.314-.764.131.131,0,0,0-.2.008,7.423,7.423,0,0,1-4.229,2.854,7.5,7.5,0,0,1-4.3-2.853.147.147,0,0,0-.114-.058.146.146,0,0,0-.117.05,2.5,2.5,0,0,1-1.291.767.25.25,0,0,0-.141.394,9.428,9.428,0,0,0,5.777,3.7.975.975,0,0,0,.194.02,1.009,1.009,0,0,0,.2-.021,9.344,9.344,0,0,0,5.683-3.707.25.25,0,0,0-.146-.394Z', 'M19.527,16.128l1.543-4.244a1.253,1.253,0,0,0-.519-1.491A16.752,16.752,0,0,0,12,8a16.763,16.763,0,0,0-8.549,2.388,1.254,1.254,0,0,0-.52,1.491l1.543,4.244a1.251,1.251,0,0,0,2.109.406C7.258,15.775,8.858,14.5,12,14.5s4.743,1.271,5.417,2.028a1.262,1.262,0,0,0,.937.42,1.227,1.227,0,0,0,.233-.023A1.253,1.253,0,0,0,19.527,16.128Z', 'M23.869,17.892a.282.282,0,0,0,.13-.26.288.288,0,0,0-.18-.23,8.583,8.583,0,0,1-2.9-1.513.245.245,0,0,0-.221-.059.248.248,0,0,0-.176.146,14.661,14.661,0,0,1-2.108,3.54.251.251,0,0,0,.061.371,8.959,8.959,0,0,0,3.8,1.365.288.288,0,0,0,.26-.11.282.282,0,0,0,.03-.28l-.745-1.472a.25.25,0,0,1,.095-.328Z']],
  ComputerBugSearch: ['computer-bug-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.312,5.52a.75.75,0,0,0-1.5,0A1.493,1.493,0,0,1,12.3,6.64a.252.252,0,0,1-.251.05,3.013,3.013,0,0,0-.985-.17,2.913,2.913,0,0,0-.956.165.251.251,0,0,1-.245-.047A1.489,1.489,0,0,1,9.312,5.52a.75.75,0,1,0-1.5,0A2.967,2.967,0,0,0,8.594,7.5a.25.25,0,0,1,.018.311,2.973,2.973,0,0,0-.537,1.435.25.25,0,0,0,.25.274H13.8a.25.25,0,0,0,.249-.274,2.968,2.968,0,0,0-.538-1.436.249.249,0,0,1,.019-.31A2.968,2.968,0,0,0,14.312,5.52Z', 'M6.562,14.27a.75.75,0,0,0,0,1.5H8.187a.251.251,0,0,1,.222.134,2.987,2.987,0,0,0,5.307,0,.251.251,0,0,1,.222-.134h1.624a.75.75,0,0,0,0-1.5h-1.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25h1.25a.75.75,0,0,0,0-1.5h-1.25a.25.25,0,0,1-.25-.25v-.25a.249.249,0,0,0-.25-.25h-5.5a.25.25,0,0,0-.25.25v.25a.249.249,0,0,1-.25.25H6.562a.75.75,0,0,0,0,1.5h1.25a.249.249,0,0,1,.25.25v1a.249.249,0,0,1-.25.25Z', 'M0,11.005a10.979,10.979,0,0,0,17.32,8.984.5.5,0,0,1,.644.056l3.475,3.511a1.5,1.5,0,0,0,2.122-2.121l-3.488-3.523a.5.5,0,0,1-.054-.638A10.993,10.993,0,1,0,0,11.005Zm11-9a9,9,0,1,1-9,9A9.01,9.01,0,0,1,11,2.005Z']],
  ComputerBug2: ['computer-bug-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.733,5.436a.25.25,0,0,1,.073.272A5.466,5.466,0,0,0,6.5,7.5a.25.25,0,0,0,.25.25h10.5a.25.25,0,0,0,.25-.25,5.455,5.455,0,0,0-.306-1.792.249.249,0,0,1,.073-.272,8.509,8.509,0,0,0,2.677-4.171A1,1,0,1,0,18.017.735a6.471,6.471,0,0,1-1.756,2.914.25.25,0,0,1-.352,0,5.47,5.47,0,0,0-7.819,0,.249.249,0,0,1-.352,0A6.492,6.492,0,0,1,5.983.734a1,1,0,0,0-1.927.531A8.507,8.507,0,0,0,6.733,5.436Z', 'M5.489,13.5H1.25a1,1,0,0,0,0,2H5.489a.249.249,0,0,1,.232.343A4.487,4.487,0,0,1,1.5,18.5a1,1,0,0,0,0,2,6.724,6.724,0,0,0,4.884-2.047.068.068,0,0,1,.074-.016A.069.069,0,0,1,6.5,18.5a5.5,5.5,0,0,0,11,0,.069.069,0,0,1,.042-.063.068.068,0,0,1,.074.016A6.724,6.724,0,0,0,22.5,20.5a1,1,0,0,0,0-2,4.487,4.487,0,0,1-4.221-2.657.25.25,0,0,1,.232-.343H22.75a1,1,0,0,0,0-2H18.511a.249.249,0,0,1-.232-.344A4.488,4.488,0,0,1,22.5,10.5a1,1,0,0,0,0-2,6.759,6.759,0,0,0-4.581,1.748.25.25,0,0,1-.419-.184V9.5a.25.25,0,0,0-.25-.25H6.75a.25.25,0,0,0-.25.25v.564a.25.25,0,0,1-.419.184A6.759,6.759,0,0,0,1.5,8.5a1,1,0,0,0,0,2,4.488,4.488,0,0,1,4.221,2.656.251.251,0,0,1-.232.344Z']],
  ShieldLock: ['shield-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.500 11.994 A1.500 1.500 0 1 0 13.500 11.994 A1.500 1.500 0 1 0 10.500 11.994 Z', 'M12,4.744a1.752,1.752,0,0,0-1.75,1.75v1.25a.5.5,0,0,0,.5.5h2.5a.5.5,0,0,0,.5-.5V6.494A1.752,1.752,0,0,0,12,4.744Z', 'M24,1.953A1.959,1.959,0,0,0,22.043.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.146,15.146,0,0,0,11.861,23.975a1,1,0,0,0,.4,0A15.145,15.145,0,0,0,23.988,9.2ZM17,14.744a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1v-5.5a1,1,0,0,1,1-1h.25a.5.5,0,0,0,.5-.5V6.494a3.25,3.25,0,0,1,6.5,0v1.25a.5.5,0,0,0,.5.5H16a1,1,0,0,1,1,1Z']],
  ShieldSettings: ['shield-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.11,2.369A22.143,22.143,0,0,0,12,.5,22.143,22.143,0,0,0,2.89,2.369,1.537,1.537,0,0,0,2,3.775v7.637A12.285,12.285,0,0,0,9.828,22.88l1.067.414a3.063,3.063,0,0,0,2.21,0l1.067-.414A12.285,12.285,0,0,0,22,11.412V3.775A1.537,1.537,0,0,0,21.11,2.369Zm-4.888,9.38.945,1.019A1.227,1.227,0,0,1,16,14.8l-1.35-.313a.911.911,0,0,0-1.076.625l-.405,1.331a1.22,1.22,0,0,1-2.336,0l-.405-1.331a.911.911,0,0,0-1.076-.625L8,14.8a1.227,1.227,0,0,1-1.168-2.033l.945-1.019a.919.919,0,0,0,0-1.248L6.833,9.482A1.227,1.227,0,0,1,8,7.449l1.35.313a.911.911,0,0,0,1.076-.625l.405-1.331a1.22,1.22,0,0,1,2.336,0l.405,1.331a.911.911,0,0,0,1.076.625L16,7.449a1.227,1.227,0,0,1,1.168,2.033L16.222,10.5A.919.919,0,0,0,16.222,11.749Z', 'M10.625 11.125 A1.375 1.375 0 1 0 13.375 11.125 A1.375 1.375 0 1 0 10.625 11.125 Z']]
};
exports["default"] = _default;